import React from "react";
import MainListItems from "../MainListItems";
import { Can } from "../../components/Can";
import { IconSettings, IconAssistant } from "../SidebarIcons";
import VoiceCallButton from "../../components/VoiceCallButton";
import NotificationSoundToggle from "../../components/NotificationSoundToggle";
import BrandLogo from "../BrandLogo";
import { i18n } from "../../translate/i18n";

export default function AppSidebar({
	user,
	statesMain,
	onToggleAdmin,
	onNavClick,
	drawerClose,
	onOpenAssistant,
	assistantOpen,
}) {
	return (
		<aside
			id="app-menu"
			className="app-menu flex h-screen shrink-0 flex-col border-e z-40 transition-all duration-300"
		>
			<BrandLogo to="/" onClick={onNavClick} />

			<div className="relative min-h-0 flex-grow overflow-y-auto">
				<nav className="p-0" onClick={onNavClick}>
					<MainListItems drawerClose={drawerClose} />
				</nav>
			</div>

			<div className="app-menu__bottom shrink-0">
				{user?.id && <NotificationSoundToggle userId={user.id} />}

				{user?.canUsePersonalAi ||
				user?.profile === "admin" ||
				user?.profile === "master" ||
				user?.personalAiUnlimited ? (
					<button
						type="button"
						title="Assistente geral"
						className={`app-menu__phone ${assistantOpen ? "app-menu__phone--active" : ""}`.trim()}
						onClick={(e) => {
							e.stopPropagation();
							onOpenAssistant?.();
							drawerClose?.();
						}}
						aria-pressed={Boolean(assistantOpen)}
						aria-label="Assistente geral"
					>
						<span className="menu-icon">
							<IconAssistant />
						</span>
						<span className="app-menu__phone-label">Assistente geral</span>
					</button>
				) : null}

				{user?.id && <VoiceCallButton />}

				<Can
					role={user?.profile}
					perform="drawer-admin-items:view"
					yes={() => (
					<button
						type="button"
						title={i18n.t("mainDrawer.listItems.administration")}
						className={`app-menu__admin ${!statesMain ? "app-menu__admin--active" : ""}`}
						onClick={(e) => {
							e.stopPropagation();
							onToggleAdmin();
						}}
						aria-pressed={!statesMain}
					>
						<span className="menu-icon">
							<IconSettings />
						</span>
						<span className="app-menu__admin-content">
							<span className="app-menu__admin-label">
								{i18n.t("mainDrawer.listItems.administration")}
							</span>
							<span className="app-menu__admin-hint">Painel do sistema</span>
						</span>
						<span className="app-menu__admin-chevron" aria-hidden>
							<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
								<path d="m9 6 6 6-6 6" />
							</svg>
						</span>
					</button>
					)}
				/>
			</div>
		</aside>
	);
}
